import React from 'react';
import { Button, Text, View } from "../../../src/Components/Themed"
import type { MyPlayerProps, OrderProps, PlayerBalanceProps } from "../../../src/types"
import { ActivityIndicator, Image } from 'react-native';
import { useColors } from '../../../src/constants/useColors';
import { Icons } from '../../../src/Components';


type ProfileBarProps = {
    me?:MyPlayerProps,
    loading:boolean,
    orders:OrderProps[],
    active_toggle:string,
    mode:'desktop'|'mobile',
    my_balance?:PlayerBalanceProps,
    onRequestAuthenticate:() => void,
    onViewProps: () => void,
    onViewOrders:() => void,
    onViewEvents:() => void,
    onViewProfile:() => void,
    onViewFlash:() => void
}


const ProfileBar = ({ me, active_toggle, mode, loading, my_balance, orders, onRequestAuthenticate, onViewProfile, onViewOrders, onViewEvents, onViewProps }:ProfileBarProps) => {
    const Colors = useColors()
    return (
        <View type='header' style={{ flexDirection:'row', borderBottomWidth:1, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
            <View transparent style={{ flexDirection:'row', alignItems:'flex-end', flex:1, marginLeft:10 }}>
                
                <Button float={active_toggle == 'events'} style={{ padding:0, width:45, height:45, borderBottomWidth:0, backgroundColor:active_toggle == 'events'?Colors.text.success:undefined, justifyContent:'center', alignItems:'center', borderColor:active_toggle == 'events' ? Colors.text.success:Colors.borders.light, borderBottomRightRadius:0, borderBottomLeftRadius:0 }} onPress={() => onViewEvents()}>
                    <Icons.ActivityIcon size={18} color={Colors.text.h1} />
                </Button>
                {mode == 'mobile' ?
                <Button float={active_toggle == 'props'} style={{ padding:0, width:45, height:45, borderBottomWidth:0, backgroundColor:active_toggle == 'props'?Colors.text.success:undefined, justifyContent:'center', alignItems:'center', borderColor:active_toggle == 'props' ? Colors.text.success:Colors.borders.light, borderBottomRightRadius:0, borderBottomLeftRadius:0 }} onPress={() => onViewProps()}>
                    <Icons.AthleteIcon size={18} color={Colors.text.h1} />
                </Button>
                :<></>}
                <Button float={active_toggle == 'orders'} style={{ padding:0, width:45, height:45, borderBottomWidth:0, backgroundColor:active_toggle == 'orders'?Colors.text.success:undefined, justifyContent:'center', alignItems:'center', borderColor:active_toggle == 'orders' ? Colors.text.success:Colors.borders.light, borderBottomRightRadius:0, borderBottomLeftRadius:0 }} onPress={() => onViewOrders()}>
                    <Icons.OrderIcon size={18} color={Colors.text.h1} />
                    <View style={{ position:'absolute', backgroundColor:Colors.text.highlight, top:-3, right:-3, height:20, width:20, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                        <Text theme='description'>{orders.length}</Text>
                    </View>
                </Button>
            </View>
            {me ?
            <Button transparent style={{ flexDirection:'row', alignItems: 'center', padding:10 }} onPress={() => onViewProfile()}>
                <View transparent style={{ flex:1, marginRight:10, paddingRight:10, alignItems:'flex-end', borderRightWidth:1, borderColor:Colors.borders.light }}>
                    <Text theme='h1'>@{me.username}</Text>
                    {my_balance ?
                    <Text theme='description' style={{ marginTop:3 }}>${my_balance.balance.toFixed(2)}</Text>
                    :<></>}
                </View>
                <Image
                    source={{ uri: me.profile_pic && me.profile_pic != '' ? me.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:40, width:40, borderRadius:100 }}
                    resizeMode='cover'
                />
            </Button>
            : loading ?
            <ActivityIndicator
                size={'small'}
                style={{ padding:10 }}
            />
            :
            <Button
                style={{ padding:10, margin:10 }}
                type='success'
                title='Get Free $20 Bet!'
                onPress={() => onRequestAuthenticate()}
            />
            }
        </View>
    )
}

export default ProfileBar